import React from "react";
import { IMAGES } from "../assets/img/ImageIndex";
import { Link } from "react-router-dom";

const WhyUsArea = () => {
  return (    
    <div className="container mw-1380">
        <div className="row">
            <div className="col-lg-7">
                <div className="why-us-content">
                    <h2>You know the business you want to grow, and we make it happen.</h2>
                    <p>Many entrepreneurs find business financing complex and time-consuming. At Envocapital, we simplify the loan process with tailored solutions that save you both time and money.</p>
                </div>
                <div className="why-us-item-wrap">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-sm-6">
                            <div className="why-us-single-item">
                                <div className="d-flex align-items-center">
                                    <img decoding="async" src={IMAGES.rating} alt="rating" style={{width:36}}/>
                                    <h3>Competitive Rates</h3>
                                </div>
                                <p>Enjoy attractive interest rates designed to help your business thrive while keeping your costs low.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="why-us-single-item">
                                <div className="d-flex align-items-center">
                                    <img decoding="async" src={IMAGES.rating} alt="rating" style={{width:36}}/>
                                    <h3>No Prepayment Fees</h3>
                                </div>
                                <p>Repay your loan early without penalties, as we reward smart financial management rather than punish it.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="why-us-single-item">
                                <div className="d-flex align-items-center">
                                    <img decoding="async" src={IMAGES.graph} alt="rating" style={{width:36}}/>
                                    <h3>Simple Qualification</h3>
                                </div>
                                <p>Fast and hassle-free approval with flexible eligibility criteria built for real businesses.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="why-us-single-item">
                                <div className="d-flex align-items-center">
                                    <img decoding="async" src={IMAGES.house} alt="house" style={{width:36}}/>
                                    <h3>Business Refinance</h3>
                                </div>
                                <p>Refinance existing loans to reduce rates and fuel your next phase of growth.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-5">
                <div className="why-us-img text-center border-bottom">
                    <img decoding="async" src={IMAGES.whyUs} alt="whyUs"/>
                    <Link to="/about-us/" className="read-more text-primary">
                        Know More About Us                                    
                        <i className="fi fi-rs-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </div>
    </div>
  );
};

export default WhyUsArea;
